import { FETCH_CURRENCY_SUCCESS_ACTION,
  FETCH_COUNTRY_LIST_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CURRENCY_SUCCESS_ACTION:
      return {
        ...state,
        CurrencyList: action.payload.rows,
        currencyDtlsCount: action.payload.count,
      };

      case FETCH_COUNTRY_LIST_SUCCESS_ACTION:
        return {
          ...state,
          CountrysList: action.payload.rows,
         
        };

    default:
      return {
        ...state,
      };
  }
}
